/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import Button from 'partial/components/Button';
import { ModalCard } from 'partial/components/Modal';

function ConfirmationModal({
  title,
  header,
  paragraph,
  firstBtnLabel,
  firstBtnColor,
  secondBtnLabel,
  secondBtnColor,
  onSubmit,
  onClose,
  isLoading,
  icon: Icon,
  // iconClassname,
}) {
  return (
    <ModalCard title={title} onClose={onClose}>
      <div className="flex items-center justify-between p-6">
        <div>
          <h1 className="text-gray-500 text-xl block">{header}</h1>
          {paragraph ? (
            <p className="text-gray-500 text-base block mt-4">{paragraph}</p>
          ) : null}
        </div>
        {Icon && <Icon className="h-20 w-20" />}
      </div>
      <div className="flex justify-center space-x-4 pb-5 w-full">
        <Button
          type="submit"
          onClick={onClose}
          isLoading={isLoading}
          primary={firstBtnColor === 'primary' || null}
          danger={firstBtnColor === 'danger' || null}
          transparent={firstBtnColor === 'transparent' || null}
        >
          {firstBtnLabel}
        </Button>
        <Button
          type="submit"
          onClick={onSubmit}
          isLoading={isLoading}
          primary={secondBtnColor === 'primary' || null}
          danger={secondBtnColor === 'danger' || null}
          transparent={secondBtnColor === 'transparent' || null}
        >
          {secondBtnLabel}
        </Button>
      </div>
    </ModalCard>
  );
}

ConfirmationModal.propTypes = {
  header: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  paragraph: PropTypes.string,
  firstBtnLabel: PropTypes.string,
  // iconClassname: PropTypes.string,
  secondBtnLabel: PropTypes.string,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.instanceOf(Function).isRequired,
  onSubmit: PropTypes.instanceOf(Function).isRequired,
  firstBtnColor: PropTypes.oneOf(['primary', 'danger', 'transparent']),
  secondBtnColor: PropTypes.oneOf(['primary', 'danger', 'transparent']),
  icon: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
};

ConfirmationModal.defaultProps = {
  isLoading: false,
  paragraph: '',
  icon: false,
  firstBtnLabel: 'Cancel',
  secondBtnLabel: 'Proceed',
  secondBtnColor: 'primary',
  firstBtnColor: 'transparent',
  // iconClassname: 'text-primary-800 h-28 w-28',
};

export default ConfirmationModal;
